import { useVelaStore } from '@/store'
import React from 'react'

interface FeedbackButtonsProps {
  messageId: string
}

const FeedbackButtons: React.FC<FeedbackButtonsProps> = ({ messageId }) => {
  const [feedbackGiven, setFeedbackGiven] = React.useState<Record<string, 'up' | 'down' | null>>({})
  const updateUserFeedback = useVelaStore(state => state.updateUserFeedback)

  const handleFeedback = async (isHelpful: boolean): Promise<void> => {
    try {
      setFeedbackGiven(prev => ({ ...prev, [messageId]: isHelpful ? 'up' : 'down' }))
      await updateUserFeedback(messageId, isHelpful)
    } catch (error) {
      console.error('Error submitting feedback:', error)
    }
  }

  // Non-async wrapper functions for onClick handlers
  const handleThumbsUp = (): void => {
    void handleFeedback(true)
  }

  const handleThumbsDown = (): void => {
    void handleFeedback(false)
  }

  return (
    <div
      style={{
        display: 'inline-flex',
        border: '1px solid #ccc',
        borderRadius: '8px',
        overflow: 'hidden',
      }}
    >
      <button
        onClick={handleThumbsUp}
        disabled={feedbackGiven[messageId] !== undefined}
        style={{
          padding: '3px 9px',
          backgroundColor: feedbackGiven[messageId] === 'up' ? '#d4f4dd' : 'white',
          color: feedbackGiven[messageId] === 'up' ? 'green' : '#333',
          border: 'none',
          cursor: feedbackGiven[messageId] ? 'default' : 'pointer',
        }}
      >
        👍
      </button>
      <div
        style={{
          width: '1px',
          backgroundColor: '#ccc',
        }}
      />
      <button
        onClick={handleThumbsDown}
        disabled={feedbackGiven[messageId] !== undefined}
        style={{
          padding: '3px 9px',
          backgroundColor: feedbackGiven[messageId] === 'down' ? '#fce4e4' : 'white',
          color: feedbackGiven[messageId] === 'down' ? 'crimson' : '#333',
          border: 'none',
          cursor: feedbackGiven[messageId] ? 'default' : 'pointer',
        }}
      >
        👎
      </button>
    </div>
  )
}

export default FeedbackButtons
